import { EUROPACE_PAYMENT_DATES } from 'cpool-constants';
import { schemaConditions, schemaLoanRequest } from 'cpool-schemas';
import { z } from 'zod';

export const schemaCreditRequestForm = z.object({
    carFinance: schemaConditions.shape.carFinance,
    dataSnippets: schemaConditions.shape.dataSnippets,
    dispositionskredite: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.dispositionskredite
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    geschaeftskredite: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.geschaeftskredite
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    immobiliendarlehen: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.immobiliendarlehen
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    kontokorrentkredite: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.kontokorrentkredite
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    kreditBetrag: schemaLoanRequest.shape.finanzbedarf.shape.finanzierungswunsch.shape.kreditbetrag,
    kreditkarten: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.kreditkarten
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    kreditLaufzeit: schemaLoanRequest.shape.finanzbedarf.shape.finanzierungswunsch.shape.laufzeitInMonaten,
    leasings: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.leasings
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    liabilityStates: schemaConditions.shape.liabilityStates,
    provision: z.number().positive().max(100),
    ratenkredite: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.ratenkredite
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    ratenzahlungstermin: z.optional(z.nativeEnum(EUROPACE_PAYMENT_DATES)),
    restschuldversicherung: schemaConditions
        .required({ residualDebtInsurance: true })
        .shape.residualDebtInsurance.required({ applicant1: true }),
    sonstigeVerbindlichkeiten: z.array(
        schemaLoanRequest.shape.haushalt.shape.verbindlichkeiten.shape.sonstigeVerbindlichkeiten
            .removeDefault()
            .unwrap()
            .element.omit({ id: true })
            .and(
                z.object({
                    hide: z.boolean().default(false),
                    id: z.string().optional(),
                }),
            ),
    ),
    verwendungszweck: schemaLoanRequest.shape.finanzbedarf.shape.finanzierungszweck,
});

export type SchemaCreditRequestForm = z.infer<typeof schemaCreditRequestForm>;
